import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommunityFocus } from 'src/app/swagger-api';

@Component({
  selector: 'app-community-focus',
  templateUrl: './community-focus.component.html',
  styleUrls: ['./community-focus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommunityFocusComponent {
  @Input({ required: true }) value: CommunityFocus;
  @Input({ required: true }) hidden: boolean;
  @Input({ required: true }) disabled: boolean;

  @Output() public focusChanged: EventEmitter<CommunityFocus> = new EventEmitter<CommunityFocus>();

  public onToggleChange($event: Event & { target: HTMLInputElement }): void {
    this.focusChanged.emit($event.target.checked ? 'CHARITY' : 'HEALTH');
  }
}
